import {css, unsafeCSS} from 'lit';
import {mobileBreakPoint} from './sizes';

// language=CSS
export const mobileHelper =
    css`
        @media (min-width: ${ unsafeCSS(mobileBreakPoint) }) {
            .hide-desktop, .mobile-only {
                display: none !important;
            }
        }
        
        @media (max-width: ${ unsafeCSS(mobileBreakPoint) }) {
            .hide-mobile, .desktop-only {
                display: none !important;
            }
        }
    `;
